/* eslint-disable import/no-anonymous-default-export */
import Notification from "../../components/shared/Notification";
import request from "../../helpers/request";

export const getEstablishmentsWithCategory = async () => {
  try {
    const token = localStorage.getItem("token");
    return await request(token)
      .get("/v2/establishment/sort")
      .then(({ data }) => {
        if (data?.errorMessage || data?.errors || data?.error) {
          Notification(
            "Error",
            data?.errorMessage ||
              data?.errors ||
              "Something went wrong. Please check your information!",
            "error"
          );
        }

        return data;
      });
  } catch (error) {
    Notification(
      "Error",
      error.response.data.error ||
        error.response.data.message ||
        "Some went wrong! Please try again later!",
      "error"
    );
  }
};

export const createEstablishment = async (data) => {
  try {
    const token = localStorage.getItem("token");
    return await request(token)
      .post("/v2/establishment/create", { ...data })
      .then(({ data }) => {
        if (data?.errorMessage || data?.errors || data?.error) {
          Notification(
            "Error",
            data?.errorMessage ||
              data?.errors ||
              "Something went wrong. Please check your information!",
            "error"
          );
        }
        Notification("Successfully created new establishment!", "", "success");
        return data;
      });
  } catch (error) {
    Notification(
      "Error",
      error.response.data.error ||
        error.response.data.message ||
        "Some went wrong! Please try again later!",
      "error"
    );
  }
};

export const getEstablishment = async () => {
  try {
    const token = localStorage.getItem("token");
    return await request(token)
      .get("/v2/establishment")
      .then(({ data }) => {
        if (data?.errorMessage || data?.errors || data?.error) {
          Notification(
            "Error",
            data?.errorMessage ||
              data?.errors ||
              "Something went wrong. Please check your information!",
            "error"
          );
        }

        return data;
      });
  } catch (error) {
    Notification(
      "Error",
      error.response.data.error ||
        error.response.data.message ||
        "Some went wrong! Please try again later!",
      "error"
    );
  }
};

export const getDefaultEstablishment = async () => {
  try {
    const token = localStorage.getItem("token");
    return await request(token)
      .get("/v2/establishment/default")
      .then(({ data }) => {
        if (data?.errorMessage || data?.errors || data?.error) {
          Notification(
            "Error",
            data?.errorMessage ||
              data?.errors ||
              "Something went wrong. Please check your information!",
            "error"
          );
        }

        return data;
      });
  } catch (error) {
    Notification(
      "Error",
      error.response.data.error ||
        error.response.data.message ||
        "Some went wrong! Please try again later!",
      "error"
    );
  }
};

export const getAllEstablishmentCategory = async () => {
  try {
    const token = localStorage.getItem("token");
    return await request(token)
      .get("/establishmentcategory/all")
      .then(({ data }) => {
        if (data?.errorMessage || data?.errors || data?.error) {
          Notification(
            "Error",
            data?.errorMessage ||
              data?.errors ||
              "Something went wrong. Please check your information!",
            "error"
          );
        }

        return data;
      });
  } catch (error) {
    Notification(
      "Error",
      error.response.data.error ||
        error.response.data.message ||
        "Some went wrong! Please try again later!",
      "error"
    );
  }
};

export const updateEstablishment = async (id, data) => {
  try {
    const token = localStorage.getItem("token");
    return await request(token)
      .patch(`/v2/establishment/update/${id}`, data)
      .then(({ data }) => {
        if (data?.errorMessage || data?.errors || data?.error) {
          Notification(
            "Error",
            data?.errorMessage ||
              data?.errors ||
              "Something went wrong. Please check your information!",
            "error"
          );
        }
        Notification("Successfully Updated Establishment", "", "success");
        return data;
      });
  } catch (error) {
    Notification(
      "Error",
      error.response.data.error ||
        error.response.data.message ||
        "Some went wrong! Please try again later!",
      "error"
    );
  }
};

export const changeEstablishmentStatus = async (id, status) => {
  try {
    const token = localStorage.getItem("token");
    return await request(token)
      .patch(`/v2/establishment/update/status/${id}?isActive=${status}`)
      .then(({ data }) => {
        if (data?.errorMessage || data?.errors || data?.error) {
          Notification(
            "Error",
            data?.errorMessage ||
              data?.errors ||
              "Something went wrong. Please check your information!",
            "error"
          );
        }

        return data;
      });
  } catch (error) {
    Notification(
      "Error",
      error.response.data.error ||
        error.response.data.message ||
        "Some went wrong! Please try again later!",
      "error"
    );
  }
};
